module.exports = __webpack_public_path__ + "img/0858-checkmark-circle.79b5e7f9.svg";